import { formatAdminDate } from "@pages/AdminDashboard/formatAdminDate";
import { AdminUserProfile } from "@types-runway/admin";

export interface UserProfileField {
  label: string;
  value: string;
}

// Pure formatter (FIND-E4, FIND-E8): turns the raw search response into the
// fixed set of readable fields the spec names, in spec order. Deliberately
// excludes every field not in that list (e.g. password) so no admin component
// can render it by accident.
export const formatUserProfile = (profile: AdminUserProfile): UserProfileField[] => [
  { label: "Name", value: `${profile.first_name} ${profile.last_name}`.trim() },
  { label: "Email", value: profile.email },
  { label: "Phone", value: profile.phone_number || "—" },
  {
    label: "Date of birth",
    // .utc(): date_of_birth is a calendar date with no meaningful time-of-day —
    // formatting in the browser's local zone can shift it a day either way.
    value: profile.date_of_birth ? formatAdminDate(profile.date_of_birth) : "—",
  },
  { label: "State", value: profile.stateOfResidence || "—" },
  { label: "Payment customer ID", value: profile.customer_id || "—" },
  { label: "Telehealth patient ID", value: profile["patient-id"] || "—" },
  { label: "Admin", value: profile.isAdmin ? "Yes" : "No" },
];
